//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from "d3";

import axios, { CancelToken } from "axios";
import { GChart } from "vue-google-charts";
export default {
  components: {
    GChart,
  },
  props: {
    chartTitle: String,
    loc: String,
    ps: String,
    pe: String,
  },
  data() {
    return {
      medium: false,
      dte: "",
      dataLine: [],
      chart: [],
      nrows:0,
      api2: `${this.$apiFix}2021snapdata.php/cut`,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 0,
        // rowsNumber: xx if getting data from a server
      },
      chartOptions: {
        backgroundColor: {
          fill: "#ffffff",
          fillOpacity: 0.5,
        },
        title: "",
        fontSize: 12,
        fontName: "Roboto Condensed",
        color: "#ffffff",
        // axes: {
        //   x: {
        //     0: { side: "top", label: "White to move" }, // Top x-axis.
        //   },
        // },
        // textStyle: {
        //   fontName: 'Open Sans',
        //   bold: true,
        //   italic: true,
        //   fontSize: 18,
        //   color: '#ffffff',
        // },
        legend: {
          position: "top",
        },
        bar: {
          groupWidth: "50%",
        },
        hAxis: {
          format: "decimal",
        },
        vAxis: {
          // title: '% OTP',
          minValue: 0,
          maxValue: 100,
          gridlines: {
            count: 0,
          },
        },
        animation: {
          duration: 1200,
          easing: "out",
          startup: true,
        },
        chartArea: {
          backgroundColor: {
            fill: "#99ddff",
            fillOpacity: 0.1,
            // 'opacity': 100
          },
          // left: 50,
          top: 20,
          bottom: 30,
          // right: 85
          // width: '400px',
          // height: '200%'
        },
        colors: ["#ffffff", "#76D7C4"],
        seriesType: "bars",
        series: {
          1: {
            type: "line",
          },
        },
        annotations: {
          alwaysOutside: true,
          textStyle: {
            fontSize: 12,
            color: "#000",
            bold: true,
          },
          // boxStyle: {
          //   stroke: "#ccc",
          //   strokeWidth: 1,
          //   rx: 0,
          //   ry: 0,
          //   gradient: {
          //     color1: "#f3e5f5",
          //     color2: "#f3e5f5",
          //     x1: "0%",
          //     y1: "0%",
          //     x2: "100%",
          //     y2: "100%",
          //     useObjectBoundingBoxUnits: false,
          //   },
          // },
          datum: {
            stem: {
              color: "none",
              length: 6,
            },
          },
          // domain: {
          //   stem: {
          //     color: "red",
          //     length: 6,
          //     style:"point"
          //   },
          // },
          highContrast: false,
        },
      },
      chartEvents: {
        select: () => {
          const table = this.$refs.gChart.chartObject;
          const selection = table.getSelection();
          const onSelectionMeaasge =
            selection.length !== 0 ? "row was selected" : "row was diselected";
          // alert("ggg");
          this.showAlert(selection[0].row);
          // console.log(selection[0].row);
        },
      },
    };
  },
  async mounted() {
    // console.log(this.chartTitle);
    this.loadData();
  },
  methods: {
    loadData() {
      axios
        .get(`${this.api2}?ps=${this.ps}&pe=${this.pe}&loc=${this.loc}&step=${this.step}`)
        .then((response) => {
          // console.log(response.data);
          this.chart = response.data.chart;
          this.nrows =  response.data.rows;
        });
    },
    showAlert(idx) {
      // console.log(this.loc, this.dept, this.chart[idx+1][4]);
      this.dte = this.chart[idx + 1][4];
      this.getData();
    },
    getData() {
      axios
        .get(
          `${this.api2}/rawdata?ps=${this.ps}&pe=${this.pe}&loc=${this.loc}&dept=${this.dept}&dte=${this.dte}`
        )
        .then((response) => {
          // console.log(response.data);
          this.dataLine = response.data;
          this.medium = true;
        });
    },
  },
};
